//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'RQ',
  data () {
    return {
      defaultJson: {
        "Oxygen consumption": "耗氧量（VO₂）",
        "Carbon dioxide production": "二氧化碳生产量（VCO₂）"
      },
      form: {
        vo2:'',
        vco2:'',
      },
      hasScore: false,
      disabled: false,
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key] == '---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form)
      if (!flag) {
        self.hasScore = false
        return '...'
      } else {
        // 呼吸商（RQ）=VCO2/VO2
        let result = form.vco2 / form.vo2
        self.hasScore = true
        return String(result.toFixed(2))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/RQ.vue